module.exports = __webpack_public_path__ + "img/Flag_of_Saudi_Arabia.a753ce0c.svg";